import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { authService } from '@/services/auth.service';
import { tokenManager } from '@/utils/tokenManager';
import { useAlertContext } from '@/contexts/alert.context';
import { useErrorHandler } from '@/shared/hooks/useErrorHandler';

export type DefinePasswordParams = {
  password: string;
  confirm: string;
};

export function useDefinePassword() {
  const navigation = useNavigate();
  const { token } = useParams<{ token: string }>();
  const [loading, setLoading] = useState(false);

  const { notify } = useAlertContext();
  const { handleError } = useErrorHandler();

  const handleSubmit = async ({ password, confirm }: DefinePasswordParams) => {
    try {
      setLoading(true);

      if (!token) {
        throw new Error('Token de definição de senha não encontrado');
      }

      await authService.resetPassword(token, password, confirm);

      notify({ message: 'Sua senha foi definida com sucesso! Você já pode acessar o sistema.', type: 'success' });

      tokenManager.clearTokens();
      window.location.href = '/login';
    } catch (error) {
      handleError(error, 'Erro ao definir senha.');
    } finally {
      setLoading(false);
    }
  };

  return {
    handleSubmit,
    loading,
  };
}
